module.exports = require("@material/ripple/dist/mdc.ripple");


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/ripple/dist/mdc.ripple","commonjs2":"@material/ripple/dist/mdc.ripple","commonjs":"@material/ripple/dist/mdc.ripple","amd":"@material/ripple/dist/mdc.ripple","umd":"@material/ripple/dist/mdc.ripple"}
// module id = 20
// module chunks = 0